<template>
  <v-dialog v-model="dialog" width="1300" :fullscreen="isMobileOrTablet()" persistent>
    <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
      <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
        <div class="w-75 text-truncate text-white">
          <span class="font-weight-bold text-h6">Edit Course Outcomes</span>
          <div class="text-caption">{{ dialog_sub_title }}</div>
        </div>
        <v-btn v-if="!loading" flat icon color="darkGreen" @click="closeDialog()">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="overflow-y: auto; max-height: calc(100vh - 140px);">
        <v-row dense>
          <v-col cols="12">
            <CourseOutcomesDetails ref="CourseOutcomesDetails" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-3" style="margin-top: auto;">
        <v-spacer></v-spacer>
        <v-btn class="mr-1" :disabled="loading" variant="outlined" elevation="1" @click="closeDialog()">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'
import CourseOutcomesDetails from '../Sub-Parent/CourseOutcomesDetails.vue'

export default defineComponent({
  components: {
    CourseOutcomesDetails,
  },
  data() {
    return {
      dialog: false,
      dialog_sub_title: null,
      loading: false,
      facultyLoad: null,
      program: null,
    }
  },
  methods: {
    async init(facultyLoad) {
      const { showSnackbar } = useSnackbar()
      this.dialog = true
      this.loading = true
      this.facultyLoad = facultyLoad
      this.dialog_sub_title = `${facultyLoad.code} - ${facultyLoad.title} (${facultyLoad.section_code || 'No Section'})`

      const programId = facultyLoad.program_id || facultyLoad.program?.id
      if (!programId) {
        showSnackbar('Program information is missing for this faculty load.', 'error')
        this.loading = false
        return
      }

      try {
        const programRes = await this.axiosCall('/programs/' + programId, 'get', null, true)
        if (!programRes || !programRes.data) {
          showSnackbar('Unable to load program details.', 'error')
          this.loading = false
          return
        }

        this.program = programRes.data
        await this.$nextTick()
        this.$refs.CourseOutcomesDetails.initData(this.facultyLoad, this.program)
      } catch (error) {
        console.error('Error loading program:', error)
        showSnackbar('Error loading program details.', 'error')
      } finally {
        this.loading = false
      }
    },
    closeDialog() {
      this.dialog = false
      this.facultyLoad = null
      this.program = null
    },
  },
})
</script>

<style scoped>
</style>
